import type { AppEnvironment } from '@/apis/infrastructures'
import { COMMITTED_TIME, getAPIBaseURL } from '@/config'
import { useStore } from '@/store'
import type { State } from '@/store/state'
import { createDolphinLogger } from '@400f/ltl-people'
import { captureException as newrelicCaptureException } from '@/newrelic'
import type { Store } from 'vuex'

export const { logger: ltlPeople } = createDolphinLogger({
  env: import.meta.env.MODE as AppEnvironment,
  baseUrl: getAPIBaseURL('bigbrotherV2grpc'),
  serviceLastCommittedAt: COMMITTED_TIME,
  onError: e => {
    newrelicCaptureException(e)
  },
})

export function buildMeta(
  store: Store<State>,
  params?: {
    referer?: string
    url?: string
  }
) {
  return {
    apiToken: store.state.apiToken?.toString(),
    referer: params?.referer ?? document.referrer,
    url: params?.url ?? window.location.href,
  }
}

export function useLogger() {
  const store = useStore()

  return {
    ltlPeople,
    buildMeta: buildMeta.bind(null, store),
  }
}
